import { Box, CardProps } from "@mui/material";
import {
  OverviewTableCell,
  OverviewTableCellBody,
  OverviewTableCellHeader,
} from "@pimo/pimo-components";
import { FC } from "react";

import { getDcRelevanceIndicator } from "../constants/colors";

export type DcRelevanceCellProps = {
  body?: string;
  header?: string;
  cardProps?: CardProps;
};

const INDICATOR_SIZE_PX = 10;

/**
 * Table cell for DC Relevance. A dot instead of a chip: filled for "Yes",
 * a hollow ring for "No", grey for anything unreviewed.
 *
 * Deliberately not `StatusIndicatorCell` from pimo-components, which renders
 * only a filled dot and drops any outline props it is handed.
 */
export const DcRelevanceCell: FC<DcRelevanceCellProps> = ({
  body,
  header,
  cardProps = {},
}) => {
  const { color, filled } = getDcRelevanceIndicator(body);

  return (
    <OverviewTableCell {...cardProps} sx={{ ...cardProps.sx }}>
      {header && <OverviewTableCellHeader>{header}</OverviewTableCellHeader>}
      <OverviewTableCellBody>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.75,
            whiteSpace: "nowrap",
          }}
        >
          <Box
            component="span"
            data-testid="DcRelevanceIndicator"
            sx={{
              flex: "0 0 auto",
              width: INDICATOR_SIZE_PX,
              height: INDICATOR_SIZE_PX,
              borderRadius: "50%",
              border: `1.5px solid ${color}`,
              backgroundColor: filled ? color : "transparent",
            }}
          />
          <Box
            component="span"
            sx={
              body === "Not reviewed" || body === "Not selected"
                ? { fontWeight: 400 }
                : undefined
            }
          >
            {body}
          </Box>
        </Box>
      </OverviewTableCellBody>
    </OverviewTableCell>
  );
};

export default DcRelevanceCell;
